import { pushDataLayer } from '@/tracking/analytics';
import { EventName } from '@/tracking/analytics/types';
import { UpSellType } from '@/api/MyBookingSession/myBookingSession.interfaces';

export const logAnalyticsMyBookingDimensionEvents = (
    eventName:
        | EventName.MY_BOOKING_UPSELL_SHOWN
        | EventName.MY_BOOKING_UPSELL_OPEN
        | EventName.MY_BOOKING_UPSELL_COMPLETED
        | EventName.MY_BOOKING_UPSELL_CLOSED,
    value: UpSellType
) => {
    pushDataLayer({
        event: eventName,
        type: value,
    });
};
